enum type {
  primary = 'primary',
  secondary = 'secondary',
}
enum size {
  medium = 'medium',
  smallTall = 'smallTall',
  small = 'small',
}

enum orientation {
  horizontal = 'horizontal',
  vertical = 'vertical',
}

export { type, size, orientation };
